// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-RYf","fullView":"styles_fullView__3r0ey"};